import React from 'react'
import { store } from '@core/Store'
import { updateUserSettingsOnDataLayer } from '../helpers'
import { useBiometricsStatus } from '@mobi/account/Areas/Verification/Biometrics/Hooks/useBiometricsStatus'
import { updateDataLayer } from '@classic/Foundation/Analytics/Analytics'

/** Initialises and keeps data layer user info updated */
export const useInitAnalyticsDataLayer = () => {
  const { isBiometricsStatusReady, isBiometricsEnabled } = useBiometricsStatus()

  React.useEffect(() => {
    if (!isBiometricsStatusReady) return
    updateDataLayer({ user: { isBiometricsEnabled } })
  }, [isBiometricsStatusReady, isBiometricsEnabled])

  React.useEffect(() => {
    updateAnalyticsDataLayer()
  }, [])
}

// =============
// Local Helpers
// =============

async function updateAnalyticsDataLayer() {
  const appState = store.getState()
  updateUserSettingsOnDataLayer(appState)
}
